/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sethoscope': {
    width: 16,
    height: 16,
    viewBox: '0 0 50.16 61.05',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle pid="0" class="cls-1" cx="5.46" cy="2.59" r="2.09"/><circle pid="1" class="cls-1" cx="23.15" cy="2.59" r="2.09"/><path pid="2" class="cls-1" d="M3.37 2.58H.52v18.23a13.92 13.92 0 1 0 27.85 0V2.58h-3.12"/><path pid="3" class="cls-1" d="M46 33.56V44.8a15.75 15.75 0 0 1-31.5 0V34.73"/><circle pid="4" class="cls-1" cx="45.98" cy="29.87" r="3.69"/><path pid="5" class="cls-1" d="M43.53 30.15a2.46 2.46 0 1 1 1.43 2"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/sethoscope.js